import { Injectable } from '@angular/core';
import * as L from 'leaflet';
import { Evented } from '../models/evented';
import { LMapService } from './l-map.service';

export type Event = 'feature-click';

@Injectable()
export class LFeaturesService extends Evented<Event> {
    featureGroup: any;

    constructor(private mapService: LMapService) {
        super();
        this.featureGroup = new L.FeatureGroup([]);
        this.mapService.getMap().addLayer(this.featureGroup);
    }
}
